import React, { PureComponent } from "react";

import { Tabs, Tab } from "./SettingsTabs.jsx";
import "./styles.styl";

export { SettingsTabsController as Tabs, Tab };

export default class SettingsTabsController extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
    this.handlers = {
      onTabClick: this.onTabClick.bind(this),
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.activeIndex !== this.props.activeIndex) {
      this.setState({ activeIndex: nextProps.activeIndex });
    }
  }

  onTabClick(activeIndex) {
    const { onChange } = this.props;

    this.setState({ activeIndex });
    onChange && onChange(activeIndex);
  }

  render() {
    return (
      <>
        <Tabs {...this.props} {...this.state} {...this.handlers} />;
      </>
    );
  }
}
